<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title>{{ $t('dealer.orderDetail.tracking.title') }}</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-select
            v-model="carrier"
            :items="carriers"
            item-text="text"
            item-value="value"
            :label="$t('dealer.orderDetail.tracking.carrier')"
            :rules="[v => !!v || $t('dealer.orderDetail.tracking.required')]"
            outlined
            dense
            class="mb-2"
          />
          <v-text-field
            v-model="trackingCode"
            :label="$t('dealer.orderDetail.tracking.trackingCode')"
            :rules="[v => !!v || $t('dealer.orderDetail.tracking.required')]"
            outlined
            dense
            class="mb-2"
          />
          <v-textarea
            v-model="notes"
            :label="$t('dealer.orderDetail.tracking.notes')"
            outlined
            dense
            rows="2"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">
          {{ $t('dealer.orderDetail.tracking.cancel') }}
        </v-btn>
        <v-btn color="primary" :disabled="!valid" @click="onSave">
          {{ $t('dealer.orderDetail.tracking.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DealerTrackingDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      carrier: null,
      trackingCode: '',
      notes: '',
      valid: false,
    };
  },

  computed: {
    carriers() {
      const keys = ['BRT', 'GLS', 'SDA', 'DHL', 'PosteItaliane', 'Altro'];
      return keys.map((k) => ({
        text: this.$t(`dealer.orderDetail.tracking.carriers.${k}`),
        value: k,
      }));
    },
  },

  methods: {
    close() {
      this.$emit('input', false);
      this.$refs.form.reset();
      this.carrier = null;
      this.trackingCode = '';
      this.notes = '';
    },

    onSave() {
      this.$emit('save', {
        carrier: this.carrier,
        trackingCode: this.trackingCode,
        notes: this.notes,
      });
      this.close();
    },
  },
};
</script>
